<template>
  <el-card>
    <el-row :gutter="20" class="header">
      <el-col :span="7">
        <el-input placeholder="请输入产品名称..." clearable v-model="queryForm.query"></el-input>
      </el-col>
      <el-button type="primary" :icon="Search" @click="initProductList">搜索</el-button>
      <el-button type="primary" @click="handleDialogValue()">添加产品</el-button>
    </el-row>
    <el-table :data="tableData" stripe style="width: 100%">

      <el-table-column prop="proName" label="产品名称" width="150" fixed/>
      <el-table-column prop="proPrice" label="产品价格" width="80" align="center" />
      <!-- <el-table-column prop="goodsPic" label="产品图片" width="150"  >
        <template v-slot="scope">
          <img :src="getServerUrl()+'/image/product/'+scope.row.proPic" width="80" height="80"/>
        </template>
      </el-table-column>

      <el-table-column prop="stock" label="产品库存" width="100" />-->

      <!-- <el-table-column prop="type" :formatter="typeFormatter" label="产品类别" width="200"/> -->


      <el-table-column prop="isHot" label="推荐" width="80" >
        <template v-slot="{row}">
          <el-switch v-model="row.isHot" @change="hotChangeHandle(row)"/>
        </template>
      </el-table-column>

      <el-table-column prop="isUp" label="上架" width="80" >
        <template v-slot="{row}">
          <el-switch v-model="row.isUp" @change="upChangeHandle(row)"/>
        </template>
      </el-table-column>

      <el-table-column prop="proSort" label="排序" width="160" align="center">
        <template v-slot="{row}">
          <el-input-number v-model="row.proSort" :min="0" size="small" controls-position="right" @change="sortChangeHandle(row)"/>
          <span class="sort-tip">越小越靠前</span>
        </template>
      </el-table-column>

      <el-table-column prop="proPic" label="产品图片" width="200" align="center">
        <template v-slot="{row}">
          <img :src="getServerUrl()+'/image/product/'+row.proPic" width="150" height="100" />
        </template>
      </el-table-column>

      <!-- <el-table-column prop="swiperSort" label="幻灯排序" width="100" align="center"/> -->

      <el-table-column prop="description" label="描述"  /> 

      <el-table-column prop="action" label="操作" width="500" fixed="right">
        <template v-slot="scope">
          <el-button type="success" @click="handleChangeImage(scope.row)">更换图片</el-button>
          <!-- 旧的内容编辑按钮：停用保留（便于回滚），改为使用「编辑产品文件」 -->
          <el-button type="primary" v-if="false" @click="handleProductContent(scope.row)">编辑产品内容</el-button>
          <el-button type="primary" @click="handleProductFile(scope.row)">编辑产品文件</el-button>
          <el-button type="primary" :icon="Edit" @click="handleDialogValue(scope.row)"></el-button>
          <el-button type="danger" :icon="Delete" @click="handleDelete(scope.row.id)"></el-button>
          <el-button type="primary" @click="handleChangeProductSwiperImage(scope.row)">轮播图片设置</el-button>
        </template>

      </el-table-column>

    </el-table>

    <el-pagination
      v-model:currentPage="queryForm.pageNum"
      :page-sizes="[10, 20, 30, 40,50]"
      :page-size="queryForm.pageSize"
      :small="small"
      :disabled="disabled"
      :background="background"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </el-card>

  <Dialog v-model="dialogVisible" :dialogTitle="dialogTitle" @initProductList="initProductList" :close-on-press-escape="false"  :dialogValue="dialogValue"/>
  <ContentDialog v-model="contentVisible" :contentTitle="contentTitle" @initProductList="initProductList" :close-on-press-escape="false" :contentValue="contentValue"/>
  <ImageDialog v-model="imageDialogVisible" :imageDialogValue="imageDialogValue" @initProductList="initProductList"/>
  <SwiperDialog v-model="swiperDialogVisible" :id="id" :swiperSort="swiperSort" @initProductList="initProductList" />
  <ProductSwiperImageDialog :productId="id" v-model="productSwiperImageDialogVisible"></ProductSwiperImageDialog>
  <ProductFileDialog :productId="id" v-model="productFileDialogVisible" @initProductList="initProductList"></ProductFileDialog>
</template>

<script setup>

import {Search,Edit,Delete } from '@element-plus/icons-vue'
import { ref } from 'vue'
import  axios from '@/util/axios'
import {getServerUrl} from "@/config/sys";
import Dialog from './components/dialog'
import ContentDialog from './components/productContent'
import ImageDialog from './components/imageDialog'
import SwiperDialog from './components/swiperDialog'
import ProductSwiperImageDialog from './components/productSwiperImageDialog'
import ProductFileDialog from './components/productFileDialog'

import {ElMessageBox,ElMessage} from 'element-plus'

const queryForm=ref({
  query:'',
  pageNum:1,
  pageSize:10
})

const total=ref(0)

const id=ref(-1)

const swiperSort=ref(-1)

const tableData=ref([
])

const dialogValue=ref({})
const contentValue=ref({})

const imageDialogValue = ref({})

const dialogTitle=ref('')
const contentTitle=ref('')

  const initProductList=async()=>{
  
  const res=await axios.post("admin/product/list",queryForm.value);
  console.log('xxx')
  console.log(res.data.data.records)
  tableData.value=res.data.data.records;
  total.value=res.data.data.total;
}

initProductList();

const dialogVisible=ref(false)

const contentVisible=ref(false)

const imageDialogVisible=ref(false)

const swiperDialogVisible=ref(false)

const productSwiperImageDialogVisible=ref(false)

const productFileDialogVisible=ref(false)


const handleSizeChange=(pageSize)=>{
  queryForm.value.pageNum=1;
  queryForm.value.pageSize=pageSize;
  initProductList();
}

const handleCurrentChange=(pageNum)=>{
  queryForm.value.pageNum=pageNum;
  initProductList();
}


const handleDialogValue = (row) => {
  if (row) {
    dialogValue.value = JSON.parse(JSON.stringify(row));
    dialogValue.value.load = true;
    dialogTitle.value = "产品修改";
  } else {
    dialogTitle.value = "产品添加";
    dialogValue.value.id = -1;
  }
  dialogVisible.value = true;
};

const handleProductContent = (row) => {
  if (row) {
    contentValue.value = JSON.parse(JSON.stringify(row));
    contentTitle.value = "编辑相关介绍";
    contentVisible.value = true;
  }
};

const handleProductFile = (row) => {
  if (row) {
    id.value = row.id;
    productFileDialogVisible.value = true;
  }
};

const handleDelete = (id) => {

  ElMessageBox.confirm(
    '您确定要删除这条记录吗?',
    '系统提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(async() => {
      console.log("id="+id)
      let res=await axios.get("admin/product/delete/"+id);
      if(res.data.code==0){
        ElMessage({
          type: 'success',
          message: '删除成功！',
        });
        initProductList();
      }else{
        ElMessage({
          type: 'error',
          message: res.data.msg,
        });
      }

    })
    .catch(() => {

    })
};


const typeFormatter = (row) => {
  return row.type.name
};



const hotChangeHandle = async (row) => {
  console.log("val="+row.id+","+row.hot);
  let res=await axios.get("admin/product/updateHot/"+row.id+"/state/"+row.isHot);
  if(res.data.code==0){
    ElMessage({
      type: 'success',
      message: '执行成功！',
    });
  }else{
    ElMessage({
      type: 'error',
      message: res.data.msg,
    });
    initProductList();
  }
}

const upChangeHandle = async (row) => {
  console.log("val="+row.id+","+row.hot);
  let res=await axios.get("admin/product/updateUp/"+row.id+"/state/"+row.isUp);
  if(res.data.code==0){
    ElMessage({
      type: 'success',
      message: '执行成功！',
    });
  }else{
    ElMessage({
      type: 'error',
      message: res.data.msg,
    });
    initProductList();
  }
}

const sortChangeHandle = async (row) => {
  console.log("sort="+row.id+","+row.proSort);
  let res=await axios.get("admin/product/updateSort/"+row.id+"/value/"+row.proSort);
  if(res.data.code==0){
    ElMessage({
      type: 'success',
      message: '排序执行成功！',
    });
    initProductList();
  }else{
    ElMessage({
      type: 'error',
      message: res.data.msg,
    });
    initProductList();
  }
}

const handleChangeImage = (row) => {
  imageDialogValue.value.flag = true;
  imageDialogValue.value.id = row.id;
  imageDialogValue.value.proPic = row.proPic;
  imageDialogVisible.value=true;
}

const handleChangeSwiper = (row) => {
  id.value=row.id;
  swiperSort.value=row.swiperSort;
  swiperDialogVisible.value=true;
}

const handleChangeProductSwiperImage = (row) => {
  id.value=row.id;
  productSwiperImageDialogVisible.value=true;
}



</script>

<style lang="scss" scoped>

.header{
  padding-bottom: 16px;
  box-sizing: border-box;
}

.el-pagination{
  padding-top: 15px;
  box-sizing: border-box;
}

.sort-tip{
  margin-left: 6px;
  color: #909399;
  font-size: 12px;
}


</style>